import {AutocompleteOption} from '@checkit/react-components';
import { useMediaQuery } from '@material-ui/core';
import { Theme, useTheme } from '@material-ui/core/styles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import React from 'react';
import { SingularProps } from '../../components/checkpointTypeAutocomplete/CheckpointTypeAutocomplete';
import NameFilter from './components/filters/NameFilter';
import SearchFilters from './components/filters/SearchFilters';

type InputChangeHandler = (value: string | null) => void;

export interface InitialValues {
  location?: AutocompleteOption;
  name: string;
  type?: AutocompleteOption;
}

export interface Props {
  onLocationChange: SingularProps['onChange'];
  initialValues: InitialValues;
  onNameChange: InputChangeHandler;
  onTypeChange: SingularProps['onChange'];
}

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    [theme.breakpoints.up('sm')]: {
      alignItems: 'flex-end',
      display: 'flex',
      flexDirection: 'row',
      marginBottom: theme.spacing(1),
      marginRight: theme.spacing(1),
      marginTop: theme.spacing(3)
    }
  },
  nameFilter: {
    flexGrow: 1
  },
  searchFilter: {
    [theme.breakpoints.down('sm')]: {
      flexGrow: 0
    },
    [theme.breakpoints.up('sm')]: {
      flexGrow: 2
    }
  },
  spacer: {
    flexGrow: 5
  }
}));

const CheckpointSearch = (props: Props) => {
  const {onLocationChange, onTypeChange, onNameChange, initialValues} = props;

  const initialLocation = initialValues.location || undefined;
  const initialType = initialValues.type || undefined;
  const initialName = initialValues.name || '';

  const classes = useStyles();
  const theme = useTheme();
  const showMobileView = useMediaQuery(theme.breakpoints.down('sm'));

  const nameFilter = (
    <div className={classes.searchFilter}>
      <NameFilter onNameChange={onNameChange} initialName={initialName} />
    </div>
  );

  const searchFilters = (
    <div className={classes.searchFilter}>
      <SearchFilters
        onLocationChange={onLocationChange}
        onTypeChange={onTypeChange}
        initialValues={{location: initialLocation, type: initialType}}
      />
    </div>
  );

  const fullView = (
    <div className={classes.container} >
      {searchFilters}
      <div className={classes.spacer} />
      {nameFilter}
    </div>
  );

  const mobileView = (
    <div className={classes.container} >
      {nameFilter}
      {searchFilters}
    </div>
  );

  return showMobileView ? mobileView : fullView;
};

export default CheckpointSearch;
